import { connect } from 'react-redux'
import TopicsManagement from './units'

const mapStateToProps = (state) => {
  const isLoading = state.TagList.isLoading ||
    state.TagAdd.isLoading ||
    state.TagEdit.isLoading ||
    state.TagRemove.isLoading
  return {
    isLoading,
  }
}

export default connect(mapStateToProps)(TopicsManagement)
